module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "fm"
    }
  }, [_vm._v("As many of the incidents in this book are based upon real events, and a few are, indeed, unadorned reminiscence, some readers may be tempted to identify the leading characters with actual people. I would therefore like to stress, with even more than the usual emphasis, that "), _c('em', [_vm._v("all")]), _vm._v(" the characters in the following pages (except the Mark I) are entirely imaginary. They are not in any way based upon, or intended to depict, the men who developed and perfected the radar talk-down system, known in real life as GCA (Ground Controlled Approach).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sequence of events also departs completely from historical facts, which seldom arrange themselves for the convenience of storytellers. Nevertheless, I hope that this novel does justice to the skill, enthusiasm, and devotion of those to whom it is dedicated.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd337ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm.vue
// module id = 69
// module chunks = 0